import findResult, { removeItemByCode } from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import actions from '../../constants';
import { findAllDatasetMarkdowns } from './state';

const destroyDataset = withDraft((draft, { items }) => {
  findAllDatasetMarkdowns(draft, { items }).forEach((category) => {
    items.forEach(({ code }) => {
      const item = findResult(draft.markdowns, category, code);
      if (item) {
        draft.markdowns[category].results = removeItemByCode(draft.markdowns[category].results, item);
      }
    });
  });
});

export default {
  [actions.DESTROY_DATASET]: destroyDataset,
};
